import React, { useEffect, useState } from "react";
// import { GoogleLogin } from "react-google-login";

import API from "../../api";

import Header from "../../components/complex/Header";
import SVG from "../../components/SVG";
import { Button } from "../../components/simple";

import styles from "./api-access.module.scss";
import { PLATFORMS } from "../Audience/PushModal/platforms";
import ModalXandr from "./ModalXandr";

const ApiAccess = () => {
  const [fbIsAuthorized, setFbIsAuthorized] = useState(false);
  const [adformIsAuthorized, setAdformIsAuthorized] = useState(false);
  // const [googleAdsIsAuthorized, setGoogleAdsIsAuthorized] = useState(false);
  const [snapchatIsAuthorized, setSnapchatIsAuthorized] = useState(false);
  const [xandrIsAuthorized, setXandrIsAuthorized] = useState(false);
  const [xandrIsShowModal, handleOpenModalXandr] = useState(false);
  const [errorXandr, clearErroXandr] = useState("");

  // const responseGoogle = response => {
  //   API.platforms.googleAds
  //     .setRefreshToken({ data: response })
  //     .then(() => setGoogleAdsIsAuthorized(true));
  // };

  const checkFbIsAuthorized = () => {
    API.platforms.fb
      .isAuthorized()
      .then(res => {
        if (res?.valid) {
          setFbIsAuthorized(true);
        } else {
          setFbIsAuthorized(false);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const checkAdFormIsAuthorized = () => {
    API.platforms.adform
      .isAuthorized()
      .then(res => {
        if (res?.valid) {
          setAdformIsAuthorized(true);
        } else {
          setAdformIsAuthorized(false);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  // const checkGoogleAdsIsAuthorized = () => {
  //   API.platforms.googleAds
  //     .isAuthorized()
  //     .then(res => {
  //       if (res?.valid) {
  //         setGoogleAdsIsAuthorized(true);
  //       } else {
  //         setGoogleAdsIsAuthorized(false);
  //       }
  //     })
  //     .catch(error => {
  //       console.log(error);
  //       setGoogleAdsIsAuthorized(false);
  //     });
  // };

  const checkSnapchatIsAuthorized = () => {
    API.platforms.snapchat
      .isAuthorized()
      .then(res => {
        if (res?.valid) {
          setSnapchatIsAuthorized(true);
        } else {
          setSnapchatIsAuthorized(false);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const checkXandrIsAuthorized = () => {
    API.platforms.xandr
      .isAuthorized()
      .then(res => {
        if (res?.valid) {
          setXandrIsAuthorized(true);
        } else {
          setXandrIsAuthorized(false);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const statusChangeCallback = async response => {
    if (response.status === "connected") {
      await API.platforms.fb.setAccessToken({
        data: {
          accessToken: response?.authResponse?.accessToken,
          dataAccessExpirationTime:
            // eslint-disable-next-line camelcase
            response?.authResponse?.data_access_expiration_time
        }
      });
      checkFbIsAuthorized();

      // testAPI();
    } else if (response.status === "not_authorized") {
      // setFbIsAuthorized(false);
      console.log("Please log into this app.");
    } else {
      // setFbIsAuthorized(false);
      console.log("Please log into facebook.");
    }
  };

  const checkLoginState = () => {
    window.FB.getLoginStatus(response => {
      statusChangeCallback(response);
    });
  };

  const handleFBLogin = () => {
    window.FB.login(checkLoginState(), {
      scope: "public_profile,ads_management,ads_read"
    });
  };

  const loadFbLoginApi = () => {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: process.env.REACT_APP_FB_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v9.0"
      });

      window.FB.Event.subscribe("auth.login", response => {
        statusChangeCallback(response);
      });

      checkLoginState();
    };

    ((d, s, id) => {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      const js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  };

  useEffect(() => {
    loadFbLoginApi();

    if (window.FB) {
      checkLoginState();
    }

    checkFbIsAuthorized();
    // checkGoogleAdsIsAuthorized();
    checkSnapchatIsAuthorized();
    checkXandrIsAuthorized();
    checkAdFormIsAuthorized();
    // eslint-disable-next-line
  }, []);

  const adformLogout = () => {
    API.platforms.adform
      .logout()
      .then(() => {
        setAdformIsAuthorized(false);
      })
      .catch(error => {
        console.log(error);
      });
  };

  // const googleAdsLogout = () => {
  //   API.platforms.googleAds
  //     .logout()
  //     .then(() => {
  //       setGoogleAdsIsAuthorized(false);
  //     })
  //     .catch(error => {
  //       console.log(error);
  //     });
  // };

  const fbLogout = () => {
    API.platforms.fb
      .logout()
      .then(() => {
        setFbIsAuthorized(false);
        window.FB.logout();
      })
      .catch(error => {
        console.log(error);
        window.FB.logout();
      });
  };

  const snapchatLogout = () => {
    API.platforms.snapchat
      .logout()
      .then(() => {
        setSnapchatIsAuthorized(false);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const handleSigninWithNewTab = async platform => {
    try {
      const authorizeLink = await API.platforms[platform].getAuthorizeLink();
      if (authorizeLink.query && authorizeLink.query.length) {
        window.open(authorizeLink.query, "_parent");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeModalXandr = () => {
    handleOpenModalXandr(false);
    clearErroXandr("");
  };

  const xandrLogout = () => {
    API.platforms.xandr
      .logout()
      .then(() => {
        setXandrIsAuthorized(false);
      })
      .catch(error => {
        console.log(error);
        setXandrIsAuthorized(false);
      });
  };

  const authModalXandr = async ({ username, password }) => {
    try {
      const authorize = await API.platforms.xandr.auth({
        data: { username, password }
      });
      if (authorize === true) {
        setXandrIsAuthorized(true);
        closeModalXandr();
      } else {
        clearErroXandr(authorize);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const renderTitle = () => {
    return (
      <div className={styles.title}>
        <SVG.Gear width={30} height={30} className={styles["title-icon"]} />
        <span>API Access</span>
      </div>
    );
  };

  return (
    <div className={styles["api-container"]}>
      <div className={styles["api-header"]}>
        <div className="container">
          <Header titleComponent={renderTitle} />
        </div>
      </div>
      <div className="container">
        <div className={styles["api-content"]}>
          <div className={styles["api-content-title"]}>
            <span>Service</span>
            {/* <div className={styles["learn-more"]}> */}
            {/*  <Link to="/"> */}
            {/*    <SVG.Document /> */}
            {/*    <span>Learn more about installing APIs</span> */}
            {/*  </Link> */}
            {/* </div> */}
          </div>
          <div className={styles["cards-list"]}>
            <div className={styles.card}>
              <div className={styles.header}>
                <div className={styles.title}>Facebook API</div>
                <div className={styles.logo}>
                  <SVG.FacebookPlatform />
                  Facebook
                </div>
              </div>
              <div className={styles.content}>
                <div className={styles.title}>IDFree API OAuth Token</div>
                <div className={styles.description}>
                  This allows you to login and pass relevant geographical
                  targeting to Facebook. No data from Facebook is collected and
                  stored by Idfree.
                </div>
                <div className={styles.buttons}>
                  {fbIsAuthorized ? (
                    <>
                      <div
                        className={`${styles.access} ${styles["access-granted"]}`}
                      >
                        Access Granted
                      </div>
                      <Button
                        className={`${styles.access} ${styles["access-delete"]}`}
                        onClick={() => {
                          fbLogout();
                        }}
                      >
                        Delete Access
                      </Button>
                    </>
                  ) : (
                    <Button
                      className={`${styles.access} ${styles["access-request"]}`}
                      onClick={() => {
                        handleFBLogin();
                      }}
                    >
                      Request Access
                    </Button>
                  )}
                </div>
              </div>
            </div>

            {/* <div className={styles.card}> */}
            {/*  <div className={styles.header}> */}
            {/*    <div className={styles.title}>Display & Video 360</div> */}
            {/*    <div className={styles.logo}> */}
            {/*      <SVG.Google360 /> */}
            {/*      Display & Video 360 */}
            {/*    </div> */}
            {/*  </div> */}
            {/*  <div className={styles.content}> */}
            {/*    <div className={styles.title}>IDFree API OAuth Token</div> */}
            {/*    <div className={styles.description}> */}
            {/*      This allows you to login and pass relevant geographical */}
            {/*      targeting to Display & Video 360. No data from Display & Video */}
            {/*      360 is collected and stored by Idfree. */}
            {/*    </div> */}
            {/*    <div className={styles.buttons}> */}
            {/*      <Button */}
            {/*        disabled */}
            {/*        className={`${styles.access} ${styles["access-request"]}`} */}
            {/*      > */}
            {/*        Request Access */}
            {/*      </Button> */}
            {/*    </div> */}
            {/*  </div> */}
            {/* </div> */}

            <div className={styles.card}>
              <div className={styles.header}>
                <div className={styles.title}>Adform</div>
                <div className={styles.logo}>
                  <SVG.AdForm />
                  Adform
                </div>
              </div>
              <div className={styles.content}>
                <div className={styles.title}>IDFree API OAuth Token</div>
                <div className={styles.description}>
                  This allows you to login and pass relevant geographical
                  targeting to Adform. No data from Adform is collected and
                  stored by Idfree.
                </div>
                <div className={styles.buttons}>
                  {adformIsAuthorized ? (
                    <>
                      <div
                        className={`${styles.access} ${styles["access-granted"]}`}
                      >
                        Access Granted
                      </div>
                      <Button
                        className={`${styles.access} ${styles["access-delete"]}`}
                        onClick={() => {
                          adformLogout();
                        }}
                      >
                        Delete Access
                      </Button>
                    </>
                  ) : (
                    <Button
                      className={`${styles.access} ${styles["access-request"]}`}
                      onClick={() => {
                        handleSigninWithNewTab(PLATFORMS.adform);
                      }}
                    >
                      Request Access
                    </Button>
                  )}
                </div>
              </div>
            </div>

            {/* <div className={styles.card}> */}
            {/*  <div className={styles.header}> */}
            {/*    <div className={styles.title}>Google Ads</div> */}
            {/*    <div className={styles.logo}> */}
            {/*      <SVG.GoogleAds /> */}
            {/*      Google Ads */}
            {/*    </div> */}
            {/*  </div> */}
            {/*  <div className={styles.content}> */}
            {/*    <div className={styles.title}>IDFree API OAuth Token</div> */}
            {/*    <div className={styles.description}> */}
            {/*      This allows you to login and pass relevant geographical */}
            {/*      targeting to Google Ads. No data from Google Ads is collected */}
            {/*      and stored by Idfree. */}
            {/*    </div> */}
            {/*    <div className={styles.buttons}> */}
            {/*      {googleAdsIsAuthorized ? ( */}
            {/*        <> */}
            {/*          <div */}
            {/*            className={`${styles.access} ${styles["access-granted"]}`} */}
            {/*          > */}
            {/*            Access Granted */}
            {/*          </div> */}
            {/*          <Button */}
            {/*            className={`${styles.access} ${styles["access-delete"]}`} */}
            {/*            onClick={() => { */}
            {/*              googleAdsLogout(); */}
            {/*            }} */}
            {/*          > */}
            {/*            Delete Access */}
            {/*          </Button> */}
            {/*        </> */}
            {/*      ) : ( */}
            {/*        <GoogleLogin */}
            {/*          clientId={process.env.REACT_APP_GOOGLE_ADS_APP_CLIENT_ID} */}
            {/*          render={renderProps => ( */}
            {/*            <button */}
            {/*              type="button" */}
            {/*              className={`${styles.access} ${styles["access-request"]}`} */}
            {/*              onClick={renderProps.onClick} */}
            {/*              disabled={renderProps.disabled} */}
            {/*            > */}
            {/*              Request Access */}
            {/*            </button> */}
            {/*          )} */}
            {/*          onSuccess={responseGoogle} */}
            {/*          onFailure={() => setGoogleAdsIsAuthorized(false)} */}
            {/*          cookiePolicy="single_host_origin" */}
            {/*          scope="https://www.googleapis.com/auth/adwords" */}
            {/*          accessType="offline" */}
            {/*          responseType="code" */}
            {/*          prompt="consent" */}
            {/*          // isSignedIn={true} */}
            {/*        /> */}
            {/*      )} */}
            {/*    </div> */}
            {/*  </div> */}
            {/* </div> */}

            <div className={styles.card}>
              <div className={styles.header}>
                <div className={styles.title}>Snapchat</div>
                <div className={styles.logo}>
                  <SVG.Snapchat />
                  Snapchat
                </div>
              </div>
              <div className={styles.content}>
                <div className={styles.title}>IDFree API OAuth Token</div>
                <div className={styles.description}>
                  This allows you to login and pass relevant geographical
                  targeting to Snapchat. No data from Snapchat is collected and
                  stored by Idfree.
                </div>
                <div className={styles.buttons}>
                  {snapchatIsAuthorized ? (
                    <>
                      <div
                        className={`${styles.access} ${styles["access-granted"]}`}
                      >
                        Access Granted
                      </div>
                      <Button
                        className={`${styles.access} ${styles["access-delete"]}`}
                        onClick={() => {
                          snapchatLogout();
                        }}
                      >
                        Delete Access
                      </Button>
                    </>
                  ) : (
                    <Button
                      className={`${styles.access} ${styles["access-request"]}`}
                      onClick={() => {
                        handleSigninWithNewTab(PLATFORMS.snapchat);
                      }}
                    >
                      Request Access
                    </Button>
                  )}
                </div>
              </div>
            </div>
            {/* xandr  */}
            <div className={styles.card}>
              <div className={styles.header}>
                <div className={styles.title}>Xandr</div>
                <div className={styles.logo}>
                  <img
                    src={SVG.Xandr}
                    alt="xandr"
                    style={{ width: 35, marginRight: 12 }}
                  />
                  Xandr
                </div>
              </div>
              <div className={styles.content}>
                <div className={styles.title}>IDFree API OAuth Token</div>
                <div className={styles.description}>
                  This allows you to login and pass relevant geographical
                  targeting to Xandr. No data from Xandr is collected and stored
                  by Idfree.
                </div>
                <div className={styles.buttons}>
                  {xandrIsAuthorized ? (
                    <>
                      <div
                        className={`${styles.access} ${styles["access-granted"]}`}
                      >
                        Access Granted
                      </div>
                      <Button
                        className={`${styles.access} ${styles["access-delete"]}`}
                        onClick={() => {
                          xandrLogout();
                        }}
                      >
                        Delete Access
                      </Button>
                    </>
                  ) : (
                    <Button
                      className={`${styles.access} ${styles["access-request"]}`}
                      onClick={() => handleOpenModalXandr(true)}
                    >
                      Request Access
                    </Button>
                  )}
                </div>
              </div>
            </div>
            {/* xandr end */}
          </div>
        </div>
      </div>
      <ModalXandr
        isShow={xandrIsShowModal}
        onClose={closeModalXandr}
        requestAccess={authModalXandr}
        error={errorXandr}
      />
    </div>
  );
};

export default ApiAccess;
